module.exports = __webpack_public_path__ + "img/logo-full-dark.3ae3c07.svg";